<template>
  <div id="app">
    <router-view v-if="!loading"/>
    <Spinner v-else :width="50" class="app__spinner" />
  </div>
</template>

<script>
// IMPORTANT: in dev mode the App component might behave odd because due to events stacking because of the hot reload feature.
// Hard refresh your page after every save in App.vue to prevent odd behavior
// (this does not affect production builds)

import { mapActions, mapState } from "vuex";
import Spinner from "./components/Spinner.vue";
import { domainPreferences } from "./services/preferences.js";
import { pushToast } from "./services/toaster.js";
export default {
  components: { Spinner },
  data() {
    return {
      timeout: null,
      loading: false,
      counter: null,
      timePassedSinceLastUpdate: 0,
      skipDistrictRefresh: false,
      refreshRate: 18
    };
  },
  computed: {
    ...mapState("feed", ["selectedDistrict", "lastUpdated"])
  },
  watch: {
    selectedDistrict: {
      handler() {
        // if less than 3 secs left till next refresh, skip the district refresh
        if (this.refreshRate - this.timePassedSinceLastUpdate < 6) {
          this.skipDistrictRefresh = true;
        }
      }
    }
  },
  async mounted() {
    await this.onMount();
    await this.registerWindowFocus();
  },
  async destroyed() {
    clearInterval(this.timeout);
  },
  methods: {
    ...mapActions("feed", [
      "getNewRssFeed",
      "fetchProvincialData",
      "getDistrictStats"
    ]),
    async onMount() {
      this.loading = true;
      await this.fetchData();
      this.redefineTimer();

      this.loading = false;
    },
    onWindowFocus() {
      const newDate = new Date();
      const lastUpdatedDate = this.lastUpdated.rss;
      // if no update has been executed in the last 40 seconds, force a realod
      // solution for idle state in different browsers
      if (newDate.getTime() - lastUpdatedDate.getTime() > 40 * 1000) {
        window.location.reload();
      }
    },
    redefineTimer() {
      this.setCounter();
      clearTimeout(this.timeout);
      this.timeout = setInterval(() => {
        this.fetchData();
        this.setCounter();
      }, this.refreshRate * 1000);
    },
    setCounter() {
      clearInterval(this.counter);
      this.timePassedSinceLastUpdate = 0;
      this.counter = setInterval(() => {
        this.timePassedSinceLastUpdate += 1;
      }, 1000);
    },
    registerWindowFocus() {
      window.removeEventListener("focus", this.onWindowFocus);
      window.addEventListener("focus", this.onWindowFocus);
    },

    async fetchData() {
      this.$store.commit("feed/LOAD_DATA", "updating");
      try {
        await this.getNewRssFeed();
        await this.fetchProvincialData(domainPreferences); // domainPreferences returns the province data depending on the domain url
        if (
          Object.keys(this.selectedDistrict).length &&
          !this.skipDistrictRefresh
        ) {
          await this.getDistrictStats(this.selectedDistrict.guid);
        }
        this.$store.commit("feed/LOAD_DATA_SUCCESS", "updating");
        this.skipDistrictRefresh = false;

        return Promise.resolve();
      } catch (err) {
        this.$store.commit("feed/LOAD_DATA_FAILED", "updating");
        pushToast(
          "failed",
          `"De data kon niet worden opgehaald. Controleer de internet verbinding!" `
        );
        return Promise.reject("Data could not be fetched");
      }
    }
  }
};
</script>

<style lang="scss">
.app {
  &__spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
